import { models } from "types/api/viewModels.ts";
import { UnavailableDataPlaceholderText } from "constants/text.ts";

export const formatPersonName = (person?: models["PersonPermissionsViewModel"]) => {
	return [person?.firstName, person?.lastName].filter(Boolean).join(" ") || UnavailableDataPlaceholderText;
};
